import { ExploreId, HexId, hexIdToHumanHexIdWithoutTitle } from "@hex/common";

import { ORG_ID } from "../../../orgs";
import { Routes } from "../../../route/routes";

export function openExplore(
  hexId: HexId,
  exploreId: ExploreId,
  openInNewTab: boolean,
) {
  const href = Routes.EXPLORE_NEW.href(ORG_ID, true, {
    hexLocator: hexIdToHumanHexIdWithoutTitle(hexId),
    exploreId,
  });
  window.open(href, openInNewTab ? "_blank" : "_self");
}
